<script>
	import UnathContext from '../../layouts/UnathContext.svelte';
	import { navigate } from 'svelte-routing';
</script>

<UnathContext title="Sign up successful">
	<div class="modal">
		<div class="modal__box modal__box--sm">
			<div class="modal__header">
				Success
			</div>
			<div class="modal__body layout">
				<div class="layout__column">
					<div class="layout__item">
						Please click on the link that has been sent to your email account to verify your email address.
					</div>
					<div class="layout__row layout__row--space-between">
						<div class="layout__item">
							<div
								class="form__button form__button--subtle"
								on:click={() => navigate('/auth/sign-in')}>
								Back to sign in
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</UnathContext>